import Vue from 'vue';
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);
import {validationMixin} from 'vuelidate';
import {required, email} from 'vuelidate/lib/validators';

import {mapActions, mapGetters, mapMutations} from "vuex";

import {
    FAVORITES_REPORT_APPERANCE
} from "@/store/action-types";

import {
    FAVORITES_REPORT_APPERANCE_SHOW_POPUP,
} from '@/store/mutation-types'

export default {
    name: 'popup-report-apperance',
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                email: '',
                listId: '',
                itemId: ''
            },
            validationErrors: {
                email: []
            }
        }
    },
    validations: {
        payload: {
            email: {
                required,
                email
            },
        }
    },
    watch: {
        'payload.email'() {
            let error = [];

            if (!this.$v.payload.email.$dirty) {
                return error;
            }

            if (!this.$v.payload.email.required) {
                error.push(this.$t('fieldRequired').replace(':name', this.$t('email')))
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t('validationEmail'))
            }
            this.validationErrors.email = error;
        },
    },
    mounted(){
        //set default params
        this.payload.listId = this.editedDataReportApperance.listId;
        this.payload.itemId = this.editedDataReportApperance.itemId;
        if(this.isAuthenticated){
            this.payload.email = this.user.email;
        }
        // end
    },
    computed: {
        ...mapGetters({
            reportApperanceLoading: 'favorites/reportApperanceLoading',
            isAuthenticated: `auth/isAuthenticated`,
            user: 'profile/user',
            editedDataReportApperance: 'favorites/editedDataReportApperance',
        }),
        disableButton(){
            return this.payload.email === '';
        },
        errorsMessages() {
            let errors = [];
            for (let i  in this.validationErrors) {
                this.validationErrors[i].forEach(e => {
                    errors.push(e);
                })
            }
            return errors;
        },
    },
    methods: {
        ...mapActions({
            reportApperance: `favorites/${FAVORITES_REPORT_APPERANCE}`
        }),
        ...mapMutations({
            changeShowPopupReportApperance: `favorites/${FAVORITES_REPORT_APPERANCE_SHOW_POPUP}`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.reportApperance(this.payload)
                    .then(() => {
                        this.changeShowPopupReportApperance(false);
                        this.$toasted.success('Уведомление будет отправлено на почту когда товар появится в наличии').goAway(5000);
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            for (let field in error.response.data.errors) {
                                this.validationErrors[field] = error.response.data.errors[field];
                            }
                        }
                    });


            }
        }
    },
    destroyed() {

    }
}
